<template>
  <NuxtLoadingIndicator color="#070a26" :throttle="0" :height="3"/>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>